<template>
  <div tabindex="0">
    <slot />
  </div>
</template>
